module.exports = __webpack_public_path__ + "img/1_018.d69462ad.jpg";